import img from "../img_us/32Façade architecturale équipée d’écrans solaires textiles pour protection thermique et design contemporain_imgupscaler..webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsFacadePage() {

  useEffect(() => {
    // Animation
    AOS.init({
      duration: 1500,
      once: true,
    });

    
    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>FACADE</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">
            Façades textiles pour architecture moderne
          </h1>

          <p data-aos="fade-up">
            Solution idéale pour habiller et rénover les façades de
            bâtiments industriels, commerciaux et publics avec des
            possibilités créatives infinies.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-facade.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Facade architecture textile" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US FACADE ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US FACADE est une solution d’habillage textile pour
            façades, permettant de moderniser l’apparence des bâtiments
            tout en améliorant leurs performances techniques.
          </p>

          <p data-aos="fade-up">
            La toile peut être imprimée pour offrir des designs
            personnalisés et s’adapter à tous les projets
            architecturaux, industriels ou commerciaux.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature
            icon="☀️"
            title="Protection UV"
            text="Réduction de l’exposition aux rayons solaires."
          />
          <Feature
            icon="🔇"
            title="Réduction du bruit"
            text="Amélioration du confort acoustique en zone urbaine."
          />
          <Feature
            icon="🌧️"
            title="Résistance aux intempéries"
            text="Toiles techniques adaptées aux conditions extérieures."
          />
          <Feature
            icon="🎨"
            title="Impression personnalisée"
            text="Possibilités créatives infinies pour la façade."
          />
          <Feature
            icon="🏗️"
            title="Rénovation rapide"
            text="Modernisation de façades sans travaux lourds."
          />
          <Feature
            icon="⚡"
            title="Installation efficace"
            text="Solution légère et rapide à mettre en œuvre."
          />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle small="Technique" big="Caractéristiques techniques" />

        <ul data-aos="fade-up" className="us-list">
          <li>Toiles techniques pour façades</li>
          <li>Protection contre les rayons UV</li>
          <li>Résistance aux intempéries</li>
          <li>Possibilité d’impression personnalisée</li>
          <li>Structure légère et durable</li>
          <li>Adapté aux bâtiments industriels et publics</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle small="Applications" big="Domaines d’utilisation" />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Bâtiments industriels",
            "Centres commerciaux",
            "Bureaux",
            "Hôtels",
            "Équipements publics",
            "Façades urbaines",
            "Rénovations",
            "Projets architecturaux",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Moderniser votre façade ?</h2>
        <p>Nos équipes vous accompagnent dans votre projet textile.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}

